import script from "./CaptainsSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptainsSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./CaptainsSidebarDetails.vue?vue&type=style&index=0&id=27cb5d3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cb5d3c"]])

export default __exports__